module.exports = __webpack_public_path__ + "res/ic_portrait_w.e2df7329b5023702eabbd3719aa6b861.png";